/* Copyright (c) 2020-present CloudIO Inc */

import { getCustomChildItemTypes } from '../../registry/Manager';
import { checkForFixedChild } from '../../utils/ManagerUtils';
import { Platform } from '../../platform/Platform';
import {
  AliasType,
  ComponentManager,
  ComponentManagerFn,
} from '../../registry/Component.type';
import { ItemType } from '../../registry/ComponentRegistry';
import { baseComponentManager } from '../../registry/Components';
import { defaultValue } from './DataStoreReference';

const name = 'Data Store Reference';

const DataStoreReferenceManager: ComponentManagerFn<'DataStoreReference'> = (
  platform: Platform,
): ComponentManager<'DataStoreReference'> => {
  return {
    ...baseComponentManager<'DataStoreReference'>(
      platform,
      'DataStoreReference',
    ),
    defaultValue,
    isChildAllowed: (page, item, childType, context) =>
      (
        [
          ...getCustomChildItemTypes('DataStoreReference'),
          'Avatar',
          'BingMap',
          'Box',
          'BoxContainer',
          'BoxList',
          'CanvasGrid',
          'Card',
          'Code',
          'D3Chart',
          'DataGrid',
          'DataList',
          'ExpressionWatchListener',
          'FlexPanel',
          'Form',
          'FormSearch',
          'HorizontalSplitPanel',
          'Mirror',
          'Paper',
          'PivotTable',
          'ProgressIndicator',
          'RowPanel',
          'SearchForm',
          'SimpleFilter',
          'SmartSearch',
          'TabPanel',
          'Timeline',
          'Toolbar',
          'UserList',
          'UserPic',
          'VerticalSplitPanel',
        ] as ItemType[]
      ).includes(childType) &&
      checkForFixedChild(platform, page, item, childType, name, context),
    props: {
      alias: {
        label: 'Alias',
        type: 'DataSourceAliasChooser',
        required: true,
        allowedTypes: [
          'CloudDataStore',
          'DataStore',
          'LocalDataStore',
          'ReadOnlyDataStore',
          'TransientDataStore',
        ],
      },
    },
    category: 'Data',
    name,
    canHaveChildren: () => true,
    getDataSourceAliasProperty: (type: AliasType) =>
      type === 'STORE' ? { aliasProp: 'alias' } : undefined,
    isDataSourceAliasUsed: (item, alias) => item.props.alias === alias,
    getDisplayText: (item, expanded) => {
      return item.props.alias;
    },
    generateShortId: (item) => item.alias,
    layout: 'sizeAware',
    icon: { iconName: 'database' },
    description: `A Datastore Reference component is a reference to specific datastore using alias and it can be used multiple times to bind same store at different places.

> Refer to Data Store's help for more details on Data Store.`,
  };
};

export default DataStoreReferenceManager;
